import { render, staticRenderFns } from "./NewCustomerGroupBtn.vue?vue&type=template&id=29297c90&scoped=true&"
import script from "./NewCustomerGroupBtn.vue?vue&type=script&lang=js&"
export * from "./NewCustomerGroupBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29297c90",
  null
  
)

export default component.exports